import { useEffect, useState } from 'react';
import {
  Container,
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  MenuItem,
  Select
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import {
  GridFooter,
  DataGrid,
  GridToolbarContainer,
  GridFooterContainer,
} from '@mui/x-data-grid';

import DeleteIcon from '@mui/icons-material/Delete';

import { useNavigate } from 'react-router-dom';
import { callApi } from '../../utils/request';

// import Header from '../../components/Header';

import Alert from '../../components/Alert';

export default function ListOperateur() {
  const [selectedRows, setSelectedRows] = useState(null);
  const [operators, setOperators] = useState([]);
  const [alert, setAlert] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const navigate = useNavigate();

  // Définition des colonnes du tableau, avec un rendu personnalisé
  // pour la colonne "Rôle" qui affiche un Select permettant de changer
  // le rôle de l'opérateur directement depuis le tableau.
  const columns = [
    // { field: 'id', headerName: 'ID', width: 100, valueFormatter: v => v.substring(0, 8) },
    { field: 'prenom', headerName: 'Prénom', width: 140 },
    { field: 'nom', headerName: 'Nom', width: 140 },
    { field: 'mail', headerName: 'Adresse mail', width: 300 },
    {
      field: 'role', flex: 1, headerName: 'Rôle', renderCell: (params) => (
        <Select
          sx={{fontSize:'inherit'}}
          value={params.row.role}
          variant="standard"
          disableUnderline
          onChange={(e) => handleChangeRole(e.target.value, params.row.id)}
          size="small"
        >
          <MenuItem value={1}>Administrateur</MenuItem>
          <MenuItem value={0}>Opérateur</MenuItem>
        </Select>
      )
    },
  ];

  useEffect(() => {
    callApi('/admin', 'GET').then((res) => {
      setOperators(res);
    }).catch((error) => {
      console.error('Error fetching operators:', error);
      setAlert({ variant: 'error', message: 'Erreur lors du chargement des opérateurs.' });
    });
  }, [alert]);

  const handleClose = (confirmation) => {
    if (confirmation) {
      deleteOperator(selectedRows);
    }
    setDeleteConfirm(false);
  };

  function deleteOperator(id) {
    callApi(`/admin/deleteOperator/${id}`, 'DELETE').then((res) => {
      if (res.alert) {
        setAlert(res.alert);
        if (res.alert.variant === 'success') {
          setTimeout(() => setAlert(null), 2500);
        }
      }
    })
  }

  const handleChangeRole = (newRole, userId) => {

    callApi(`/admin/updateOperator`, 'POST', { id: userId, role: newRole })
      .then((res) => {
        if (res.alert) {
          setAlert(res.alert);
          if (res.alert.variant === 'success') {
            setTimeout(() => setAlert(null), 2500);
          }
        }
      })
      .catch((error) => {
        console.error('Error updating operator role:', error);
        setAlert({ variant: 'error', message: 'Erreur lors de la modification du rôle de l\'opérateur.' });
      });
  };

  // Bar d'outils personnalisée du DataGrid, affichée en haut du tableau,
  // contenant un bouton pour naviguer vers la page de création d'un nouvel opérateur.
  function EditToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <Grid container alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
        <Button
          color="warning"
          startIcon={<AddIcon />}
          onClick={() => navigate('/dashboard/createOperateur')}
          children="Créer un opérateur"
        />
        </Grid>
      </GridToolbarContainer>
    );
  }

  // Bar d'outils personnalisée du DataGrid, affichée en bas du tableau,
  // contenant un bouton de suppression de l'opérateur sélectionné.
  function FooterToolbar(props) {
    const { sx, ...other } = props ?? {};
    return (
      <GridFooterContainer
                {...other}
                sx={[{ justifyContent: selectedRows ? 'space-between' : 'end' }, sx]}
            >
        {/* Affichage du bouton de suppression uniquement si une ligne est sélectionnée */}
        {selectedRows &&
          <Box display="flex" gap={1}>
            <Button
              sx={{ml:2}}
              color="error"
              size="small"
              startIcon={<DeleteIcon />}
              onClick={() => setDeleteConfirm(true)}
              children="Supprimer"
            />
          </Box>}
        <GridFooter sx={{ border: 'none' }} />
      </GridFooterContainer>
    )
  }

  return (
    <>
    {/* Affichage des alertes */}
    {alert && <Alert alert={alert}/>}

    <Container>
      {/* Titre de la page */}
      <Typography variant="h4" align='center' sx={{ marginBottom: '20px' }} children="Liste des opérateurs" />

      {/* Tableau des opérateurs */} 
      <Box sx={{ width: '100%' }}>
        <DataGrid
          density="compact"
          rows={operators}
          columns={columns}
          onRowSelectionModelChange={(rowSelect) => setSelectedRows([...rowSelect.ids][0])}
          disableColumnMenu
          disableColumnResize
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10]}
          sx={{ backgroundColor: 'white' }}
          showToolbar
          slots={{
            toolbar: EditToolbar, footer: FooterToolbar
          }}
        />
      </Box>

      {/* Dialog de confirmation de suppression d'un opérateur */}
      <Dialog
        open={deleteConfirm}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" children="Suppression d'un opérateur" />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
                    Êtes-vous sûr de bien vouloir supprimer cette simulation ?
                    <br/>
                    Cette action <b>est irréversible</b>.
                </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} children="Annuler" />
          <Button onClick={() => handleClose(true)} color="error" children="Supprimer" />
        </DialogActions>
      </Dialog>
    </Container>
    </>
  );
}
